<template>
  <ModalDialog
    ref="dialog"
    title="Email Customer Price List"
    :submitting="submitting"
    :scrollable="true"
    :submitDisabled="currentlyUploading"
    submitTitle="Email"
    icon="fa-envelope"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" v-if="contactData">
      <EmailMessageForm 
        :contactId="contactId"
        :templateType="MessageTemplateTypes.customerPriceList"
        :messageTemplateUpdateFn="messageTemplateUpdateFn"
        :previewLink="previewLink"
        @uploading="currentlyUploading = $event"
        @update="emailDetails = $event"
      />
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { MessageTemplateTypes, CommunicationMethodTypes } from '@/store/types'

export default {
  name: "CustomerPriceListEmailDialog",
  mixins: [
    ModalDialogMixin,
    form,
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    contactData: Object,
    contactId: Number,
    customerPriceListId: Number,
  },
  data() {
    return {
      dialogForm: {},
      emailDetails: { },
      submitting: false,
      currentlyUploading: false,

      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    previewLink() {
      return `/contacts/${this.contactId}/customer/pricelist/${this.customerPriceListId}/report`
    }
  },
  methods: {
    show() {
      // Reset form
      this.emailData = { }
      this.dialogForm = { }
      this.submitting = false

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var priceListEmailData = {
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        emailPersonList: this.emailDetails.contactPersonList.map(person => { return {contactPersonId: person.id } }),
        uploadFileList: this.emailDetails.uploadFileList,
        ccList: this.emailDetails.ccList
      }

      this.$apiService.pricingService.emailCustomerPriceList(this.contactId, this.$props.customerPriceListId, priceListEmailData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.pricingService.getCustomerPriceListEmailTemplate(this.$props.contactId, this.$props.customerPriceListId, messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>